/* global __LOYALLIST_ENTRY_POINT__ */
import bcomCfg from './config.bcom.mjs';
import mcomCfg from './config.mcom.mjs';

const entry =
  typeof __LOYALLIST_ENTRY_POINT__ !== 'undefined' ? __LOYALLIST_ENTRY_POINT__ : process.env.VITE_ENTRY_POINT || process.env.ENTRY_POINT || 'bcom';
const cfg = entry === 'mcom' ? mcomCfg : bcomCfg;

export default cfg;

export const {
  brand,
  links,
  CREDITCARD_OFFER,
  helpFulLinksHeader,
  OFFERS_CAROUSEL,
  ASSOCIATION_PAGE,
  MODAL_CONTENT,
  ASSOCIATION_PAGE_HEADER,
  TRIPLE_POINTS_DAYS,
  PERSONAL_STYLIST_BANNER,
  PERKS_LIST,
  TIER_NAME,
  PAGE_HEADER,
  TIER_TRACKER,
  HOW_IT_WORKS,
  EXCLUSIONS,
  EARN_RATE,
  earnPoints,
  benefitsHeader,
  benefitsHeaderStyle,
  benefitsSubtitleStyle,
  benefitsSectionStyle,
  UNIFIED_SUMMARY_ERROR_MESSAGE,
  EVENT_TAGGING,
} = cfg;
